import { Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';

export function exportChassisInvoiceDueTableColumns(): ColumnsType<
  Record<string, any>
> {
  const columns: ColumnsType<Record<string, any>> = [
    {
      title: 'Chassi',
      key: 'chassi',
      dataIndex: 'chassis',
      render: (value) => {
        return <div style={{ fontFamily: 'Consolas' }}>{value}</div>;
      },
      width: '20%',
    },
    {
      title: 'Número da DUE',
      dataIndex: 'due_number',
      key: 'due_number',
      render: (value) => {
        return <div style={{ fontFamily: 'Consolas' }}>{value}</div>;
      },
    },
    {
      title: 'Chave de Acesso',
      dataIndex: 'access_key',
      key: 'access_key',
      render: (value) => {
        return <div style={{ fontFamily: 'Consolas' }}>{value}</div>;
      },
    },
  ];

  return columns;
}
